/**
 * Base for ForeTees API record editors
 * TODO:  Break ths up in to multiple mixins
 */
import NavRoute from '../navRoute'
import HeaderMethods from '../headerMethods'
import Rules from '../rules'
import ErrorHandler from '../errorHandler'
import boolean from '../boolean'
import {forceFloat, forceInt, forceCurrency, displayPercent, setLocalOrGlobalValue, getLocalOrGlobalValue, clearLocalOrGlobalValue} from '../../util/helpers'
import moment from 'moment'
import cloner from './mixins/cloner'
import apiHelpers from './mixins/apiHelpers'
import itemHelpers from './mixins/itemHelpers'
import ItemSelectTable from '../../components/ItemSelectTable'

// Something with Vue's reactive properties prevents us from putting this dialog object in data.
var exitPrompt = null // eslint-disable-line

export default {
  components: {ItemSelectTable},
  mixins: [apiHelpers, itemHelpers, cloner, HeaderMethods, Rules, NavRoute, ErrorHandler, boolean],
  data () {
    return {
      showingItem: false,
      selectedItemId: undefined,
      search: '',
      items: [],
      disableButtons: false,
      disableAdd: false,
      hasLoadedList: false,
      lastSelectedRowsPerPage: null,
      selectedPage: null,
      pagination: {},
      apiPagination: false,
      totalListItems: undefined
    }
  },
  props: {
    id: [Number, String, Object],
    showId: [Number, String, Object],
    cloneId: [Number, String],
    listTitle: String,
    parentId: [Number, String, Object],
    itemList: Array,
    listFilter: [Function, Array],
    listSortOrder: [Function, Array],
    showIdQuery: {
      type: String,
      default: 'showId'
    }
  },
  computed: {
    hasAddAccess () {
      return true
    },
    showItem () {
      return this.selectedItemId !== undefined || this.showId !== undefined || this.id !== undefined
    },
    showItemOnly () {
      return this.id !== undefined
    },
    parsedListFilter () {
      if (typeof this.listFilter === 'function') {
        return this.listFilter(this)
      } else {
        return this.listFilter
      }
    },
    parsedListSortOrder () {
      if (typeof this.listSortOrder === 'function') {
        return this.listSortOrder(this)
      } else {
        return this.listSortOrder
      }
    },
    parsedListTitle () {
      if (typeof this.listTitle === 'function') {
        return this.listTitle(this)
      } else {
        return this.listTitle
      }
    },
    maxSelectDate () {
      // By default, clamp max select date to now + 10 years
      return moment().add(10, 'years').format('YYYY-MM-DD')
    },
    pageTitle () {
      return this.listPageTitle
    },
    itemPageTitle () {
      return this.type
    },
    listPageTitle () {
      return this.parsedListTitle || this.routeTitle || this.types
    },
    isFormDisabled () {
      return this.readOnly || this.isDataLoading
    },
    instanceKey () {
      return 'list'
    },
    // TODO:  Clean this up
    defaultContextMenu () {
      var results = []
      // List of items
      if (this.hasAddAccess) {
        results.push(
          ...[
            {
              title: 'Add',
              icon: 'mdi-plus',
              hide: this.disableAdd,
              action: this.addNewItem
            }
          ]
        )
      }
      results.push(
        ...[
          {
            title: 'Refresh List',
            icon: 'mdi-refresh',
            action: this.refreshList
          }
        ]
      )
      return results
    },
    pageBarSaveButton () {
      return {
        action: this.addNewItem,
        toolTip: 'Add New ' + this.type,
        text: 'New'
      }
    }
  },
  methods: {
    forceInt,
    forceFloat,
    forceCurrency,
    displayPercent,
    beforeLoadData () {
      // Overridden. Do not change
      return true
    },
    loadData () {
      if (this.selectedItemId !== undefined || this.showId !== undefined || this.id !== undefined || this.$route.query[this.showIdQuery] !== undefined) return
      if (!this.beforeLoadData()) return
      console.log('Loading List Data')
      this.isLoading = 0
      // Show listing
      this.loadList()
    },
    addNewItem () {
      this.editItem(null)
    },
    addEditItemQueryFilter (query, id) {
      // Don't modify. Overridden.
      return query
    },
    editItem (id) {
      if (this.showingItem || this.selectedItemId === id) {
        console.warn('Already showing an item.  Skipping.')
        return
      }
      console.log('Showing Item', id)
      this.showingItem = true
      const query = Object.assign({}, this.$route.query)
      const itemQuery = {
        ...query,
        sxp: '1' // Don't rest scroll position
      }
      itemQuery[this.showIdQuery] = id
      this.$router.push({query: this.addEditItemQueryFilter(itemQuery, id)})
    },
    beforeLoad (data) {
      // Overridden by component.  Do not put code here
    },
    listResourceCommands () {
      // Overridden by component.  Do not put code here
      return []
    },
    _setPagination () {
      // TODO: Simplify this.  It's complicated a bit by the loaded component being re-used by multiple paths
      const defaultRowsPerPage = this.$ftAC.defaultRows
      if (!this.pagination) return
      const path = this.$route.path
      const rowsPerPageStorageKey = 'rowsPerPage'
      const savedRowsPerPage = parseInt(getLocalOrGlobalValue(path, rowsPerPageStorageKey), 10)
      var setRowsPerPage
      const startRpp = this.pagination.itemsPerPage
      const selectedPage = this.pagination.page || 1
      if (selectedPage !== this.selectedPage) {
        this.selectedPage = selectedPage
      }
      if (this.lastSelectedRowsPerPage === null || this.pagination.itemsPerPage  === undefined) {
        // Nothing set.  Set to default or stored
        console.log('Setting rows per page', savedRowsPerPage, defaultRowsPerPage)
        setRowsPerPage = !isNaN(savedRowsPerPage) ? parseInt(savedRowsPerPage, 10) : defaultRowsPerPage
      } else {
        setRowsPerPage = this.pagination.itemsPerPage  || defaultRowsPerPage
      }
      if (setRowsPerPage === -1) setRowsPerPage = 500 // We can't allow over 500.  It will freeze the system.  Even 500 is too many for some listing pages.
      if (startRpp !== setRowsPerPage) {
        this.pagination = {itemsPerPage: setRowsPerPage}
      }
      this.lastSelectedRowsPerPage = setRowsPerPage
      if (!isNaN(savedRowsPerPage) && setRowsPerPage === defaultRowsPerPage) {
        console.log('Clearing rows per page', savedRowsPerPage)
        clearLocalOrGlobalValue(path, rowsPerPageStorageKey)
      } else if (savedRowsPerPage !== setRowsPerPage) {
        console.log('Saving rows per page', setRowsPerPage)
        setLocalOrGlobalValue(path, rowsPerPageStorageKey, setRowsPerPage)
      }
    },
    _beforeItemsLoad (data) {
      this._setPagination()
      this.beforeItemsLoad(data)
    },
    beforeItemsLoad (data) {
      // Do nothing here. Overridden by Component
    },
    _afterItemsLoad (data) {
      this.afterItemsLoad(data)
    },
    afterItemsLoad (data) {
      // Do nothing here. Overridden by Component
    },
    _itemsListFilter (data) {
      return this.itemsListFilter(data)
    },
    itemsListFilter (data) {
      // Do nothing here. Overridden by Component
      return data
    },
    listCommand () {
      const result = {
        command: this.apiRecordCommand,
        load: (data, r) => {
          this.items = this._itemsListFilter(data)
          this.hasLoadedList = true
          const totalResults = r.result_total_size
          console.log('For List Load ...', data, r, totalResults)
          if (this.apiPagination && totalResults !== undefined) {
            console.log('Total results', totalResults)
            this.totalListItems = totalResults
          } else {
            this.totalListItems = null
          }
        },
        beforeLoad: this._beforeItemsLoad,
        afterLoad: this._afterItemsLoad,
        loading: this.setIsLoading
      }
      if (this.parentId) {
        this.addCommandParam(result, 'parent_id', this.parentId)
      }
      if (this.apiPagination) {
        var resultsPerPage = this.lastSelectedRowsPerPage
        if (resultsPerPage === -1) {
          resultsPerPage = 500
        }
        if (resultsPerPage > 0) {
          const selectedPage = this.selectedPage || 1
          const offset = resultsPerPage * (selectedPage - 1)
          this.addCommandParam(result, 'limit_offset', offset)
          this.addCommandParam(result, 'limit', resultsPerPage)
        }
      }
      const listFilter = []
      if (this.parsedListFilter) {
        listFilter.push(...this.parsedListFilter)
      }
      if (listFilter && listFilter.length) {
        this.addCommandParam(result, 'filter', listFilter)
      }
      const listSortOrder = []
      if (this.parsedListSortOrder) {
        listSortOrder.push(...this.parsedListSortOrder)
      }
      if (listSortOrder && listSortOrder.length) {
        this.addCommandParam(result, 'order_by', listSortOrder)
      }
      return result
    },
    listCommandFilter (command) {
      // Overridden by component.  Do not put code here
      return command
    },
    refreshList () {
      this.loadList()
    },
    loadList () {
      var commands = [
        ...this.listResourceCommands(),
        this.listCommandFilter(this.listCommand())
      ]
      this.$ftAPI().get(this.addResourceErrorHandler(commands))
    },
    onRouteChange () {
      // Overridden.  Do not change
    },
    _onRouteChange () {
      this.onRouteChange()
      this.selectedItemId = this.id !== undefined ? this.id : this.showId
      this.lastSelectedRowsPerPage = null
      this.hasLoadedList = false
      if (this.selectedItemId !== undefined) {
        setTimeout(() => {
          console.log('Finished showing item', this.selectedItemId)
          this.showingItem = false
        }, 250)
      }
      this._setPagination()
      console.log('Set Selected Item On Route Change', this.selectedItemId, this.id, this.showId)
      this.loadData()
    }
  },
  created () {
    this._setPagination()
    console.log('Created:', this)
  },
  mounted () {
    console.log('Mounted:', this)
    this._onRouteChange()
  },
  watch: {
    id (val) {
      console.log('id Prop Changed', val)
      this.selectedItemId = val
    },
    showId (val) {
      console.log('showId Prop Changed', val)
      this.selectedItemId = val
    },
    selectedItemId (val) {
      console.log('Selected Item Changed', val)
      if (!val && !this.showItemOnly) {
        // ???
      } else {
        // Load item
      }
    },
    $route (to, from) {
      console.log('Item Select Route changed:', to, from)
      this._onRouteChange()
    },
    pagination: {
      handler () {
        // const defaultRowsPerPage = this.$ftAC.defaultRows
        // console.log('Pagination Changed', this.pagination, localStorage, this.pagination.itemsPerPage, defaultRowsPerPage)
        this._setPagination()
      },
      deep: true
    },
    selectedPage (newVal, oldVal) {
      if (!this.apiPagination || !this.hasLoadedList || newVal === oldVal) return
      this.refreshList()
    },
    lastSelectedRowsPerPage (newVal, oldVal) {
      if (!this.apiPagination || !this.hasLoadedList || newVal === oldVal) return
      this.refreshList()
    }
  }
}
